import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gold border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    const dest = ["admin", "agent", "gestionnaire", "concierge"].includes(user.role)
      ? "/admin" : user.role === "owner" ? "/espace-proprietaire" : user.role === "partenaire" ? "/espace-partenaire" : "/espace-client";
    return <Navigate to={dest} replace />;
  }
  return children;
};
